// src/components/MainContent/ImageSection.jsx
import React from 'react';

const ImageSection = () => (
  <div className="image-section">
    <img 
      src="/img.svg" 
      alt="People talking abstract illustration"
      className="abstract-image"
    />
  </div>
);

export default ImageSection;